import { render, staticRenderFns } from "./trocarSenhaAssociado.vue?vue&type=template&id=56d4ea4c&"
import script from "./trocarSenhaAssociado.vue?vue&type=script&lang=js&"
export * from "./trocarSenhaAssociado.vue?vue&type=script&lang=js&"
import style0 from "./trocarSenhaAssociado.vue?vue&type=style&index=0&id=56d4ea4c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports